export const APP_NAME = 'agency_page_perseus';
